import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { init as initContentfulExtension } from 'contentful-ui-extensions-sdk';

Vue.config.productionTip = false;

function initVue () {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}

// we're in an iframe setup, so initialize with the contentful SDK
if (window.parent !== window) {
  initContentfulExtension(extension => {
    Vue.prototype.$extension = extension;
    initVue();
  });
}
else {
  initVue();
}
